import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTabsModule} from '@angular/material/tabs';
import {UtilsModule} from '../utils/utils.module';
import {LoaderComponent} from './loader.component';

@NgModule({
    imports: [
        CommonModule,
        UtilsModule,
        FlexLayoutModule,
        MatCardModule,
        MatTabsModule,
        MatDialogModule,
        MatButtonModule
    ],
    entryComponents: [LoaderComponent],
    declarations: [LoaderComponent],
    exports: [LoaderComponent]
})
export class LoaderModule {
}

